import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router';
// import { LuClock8 } from "react-icons/lu";
import { BsEnvelope } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { languageStore } from '../../subscriber/Language';
// import { MdOutlinePhoneInTalk } from "react-icons/md";
import ContactForm from '../../components/contact_form/ContactForm';
import HeroSection from '../../components/HeroSection';
import SeoHelmet from '../../components/SeoHelmet';
import staticBlogs from '../../data/blogs.json';
import Layout from "../layout";

import chefImage from '../../assets/chef_luca_in_safrom_filed.png';
import contactImage from '../../assets/_I5A4778_1.png';
import backgroundImage from '../../assets/tGbms4_2_.png';

const ContactInfoCard = ({ Icon, title, description }) => (
    <div className="p-5">
        <Icon className="text-accent text-5xl mb-4 block text-center" />
        <h3 className="text-primary text-xl font-semibold mb-2">{title}</h3>
        <p className="text-text">{description}</p>
    </div>
);

const ContactUs = () => {
    const location = useLocation();
    const { getPageTranslations } = languageStore;
    const t = getPageTranslations('contact');

    // update the page title using Helmet
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    // 👇 SEO meta only from Home
    const seoConect = staticBlogs.find(b => b.slug === 'contact_us');

    return (
        <Layout>
            <SeoHelmet
                title={seoConect.name}
                description={seoConect.sort_description}
                image={seoConect.path}
                url={seoConect.url}
            />
            <div className="bg-[#FFF]">
                {/* Hero Section */}
                <HeroSection
                    backgroundImage={chefImage}
                    title={t.getInTouch}
                />

                {/* Contact Info Section */}
                <section className="py-24 px-4">
                    <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <ContactInfoCard
                            Icon={CiLocationOn}
                            title={t.ourOffice}
                            description={t.officeAddress}
                        />
                        <ContactInfoCard
                            Icon={BsEnvelope}
                            title={t.attentionToDetail}
                            description={t.emailAddresses}
                        />
                        {/* <ContactInfoCard
                            Icon={MdOutlinePhoneInTalk}
                            title={t.phoneNumber}
                            description={t.phoneNumbers}
                        />
                        <ContactInfoCard
                            Icon={LuClock8}
                            title={t.hourOfOperation}
                            description={t.operationHours}
                        /> */}
                    </div>
                </section>

                {/* Contact Form Section */}
                <section className="py-24 px-4 overflow-hidden">
                    <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12">
                        <div>
                            <h5 className="text-secondary mb-2">{t.contactUs}</h5>
                            <h2 className="text-primary text-3xl font-bold mb-4">{t.reachOutToUs}</h2>
                            <ContactForm t={t.form} />
                            {/* Add your contact form component here */}
                        </div>
                        <div className="relative">
                            <img
                                src={backgroundImage}
                                alt=""
                                className="absolute top-1/2 left-0 hidden lg:block z-0"
                                style={{
                                    transform: 'translateX(-168px) translateY(-50%) rotate(-9deg)',
                                    opacity: 0.35,
                                }}
                                width={216}
                                height={216}
                            />
                            <img
                                src={contactImage}
                                alt={t.chefsAreBrainstorming}
                                className="object-cover relative z-10 rounded-lg shadow-lg"
                                width={650}
                                height={650}
                            />
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default observer(ContactUs);
